export const environment = {
  production: false,
  cenplexBookingApiBaseUrl: 'https://api.int.cenplexbooking.ch/v1',
  // cenplexBookingApiBaseUrl: 'http://localhost:5134/v1',
  // cenplexBookingWebUrl: 'https://dev-cenplex-booking-web-aca.salmonfield-07c50e2a.switzerlandnorth.azurecontainerapps.io',
  cenplexBookingWebUrl: 'https://web.int.cenplexbooking.ch',
  clientId: 'dev-configurator'
};
